var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade"}},[(_vm.notification.show)?_c('div',{staticClass:"notification",class:_vm.notification.class},[_c('button',{staticClass:"delete",attrs:{"type":"button"},on:{"click":_vm.close}}),_vm._v(" "+_vm._s(_vm.notification.message)+" ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }